import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { APP_THEME } from './const/config';

import(`./assets/app-${APP_THEME}.css`)
  .then(() => {
    const basename = process.env.REACT_APP_CUSTOM_BASENAME ? process.env.REACT_APP_CUSTOM_BASENAME + '/' : '/';
    const faviconPath = `${basename}${APP_THEME}-favicon.png`;
    const existingFavicon = document.querySelector(
      "link[rel*='icon']"
    ) as HTMLLinkElement | null;

    if (existingFavicon) {
      existingFavicon.href = faviconPath;
    } else {
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      newFavicon.href = faviconPath;
      document.head.appendChild(newFavicon);
    }

    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    reportWebVitals();
  })
  .catch((err) => {
    console.error(`Failed to load theme: ${APP_THEME}`, err);
  });

// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
